import { Box, Card, Typography } from "@mui/material";
import QRCode from "../../../qrCode/qrCode";
import { useState } from "react";
import FotoEdit from "../../../utils/fotoEdit";
import './fichaAdmin.css';
import StatusEstabelecimento from "../../../utils/status/statusEstabelecimento";

export default function FichaImportadorSingular({ importador, local, list }) {
  // const user = useSelector((state) => state.account.user);
  // const { id } = useParams()
  const [openEditFoto, setOpenEditFoto] = useState(false);
  const baseUrl = window.location.origin;

  return (
    <>
      <Card>

        <Box className="profile-container">
          <div className="profile-card">
            <div className={`${list === true ? "profile-card-content-1" : "profile-card-content"}`}>
              {/* Image Section */}
              <div className="profile-image-section">

                <img
                  src={importador?.logo}
                  alt="Profile"
                  className="profile-image"
                />

                <FotoEdit
                  openEditFoto={openEditFoto}
                  setOpenEditFoto={setOpenEditFoto}
                  dadosPessoais={importador}
                  viewEdit={true}
                />

                <div className="profile-function-badge">
                  <StatusEstabelecimento status={importador?.status} />
                </div>
              </div>

              <div className="profile-info-section">
                <div className="profile-qr-container">
                  <div className="profile-qr-box">
                    <QRCode
                      link={`${baseUrl}/verifica-estabecimento/${importador?._id}`}
                      style={{ width: 40, height: 40, color: '#374151' }}
                    />
                  </div>
                </div>

                <div className="profile-info-content">
                  <div className="profile-name-section">
                    <h1 className="profile-name-title">
                      {importador?.nome || "N/A"}
                    </h1>
                    <div className="profile-name-underline"></div>
                  </div>

                  <div >
                    <Typography noWrap variant="subtitle1"><strong>Nome:</strong>  {importador?.nome ?? '####'}</Typography>
                    <Typography variant="subtitle1"><strong>Indentificação:</strong> {importador?.numeroAutorizacao ?? '####'}</Typography>
                    <Typography variant="subtitle1"><strong>Contacto:</strong> {importador?.tel1 ?? '####'}</Typography>
                    <Typography noWrap variant="subtitle1"><strong>E-mail:</strong> {importador?.email ?? '####'}</Typography>
                    <Typography variant="subtitle1"><strong>Provincia:</strong> {importador?.provincia ?? '####'}</Typography>
                    <Typography variant="subtitle1"><strong>Município:</strong> {importador?.municipio ?? '####'}</Typography>
                    <Typography noWrap variant="subtitle1"><strong>Bairro:</strong> {importador?.bairro ?? '####'}</Typography>
                    <Typography noWrap variant="subtitle1"><strong>Rua:</strong> {importador?.rua ?? '####'}</Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>

        <embed
          id="pdfIframe"
          title={`PDF Viewer`}
          src={[importador?.docs?.copiaDI]}
          width="100%"
          height="800px"
          style={{ border: 'none', marginTop: 10 }}
        />
      </Card>
    </>
  );
}
